<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo2.png" width="150" alt="MCSS ISIKULKAS" />
        <img
          class="navbar-brand-minimized"
          src="img/logo2-2.png"
          width="30"
          height="30"
          alt="MCSS ISIKULKAS"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <!-- <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
        <b-nav-item class="px-3">
          {{username}}
          <small>({{division_name}} / {{position_name}})</small>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item>-->
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <b-card>
            <marquee class="marquee-breadcrumb" v-html="marquee_text"></marquee>
          </b-card>
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="http://35.198.220.165">MBS</a>
        <span class="ml-1">&copy; 2018 Mbs.</span>
      </div>

      <marquee class="marquee" v-html="marquee_text"></marquee>

      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="http://35.198.220.165">MBS</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import axios from "axios";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: [],
      listMenu: []
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    username() {
      return localStorage.getItem("name");
    },
    division_name() {
      return localStorage.getItem("division_name");
    },
    position_name() {
      return localStorage.getItem("position_name");
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    marquee_text() {
      let text = "";
      text = "These system is running on staging server, and whole data information is for staging purposes only and should not be used in a live environment";
      // text =
      //   "1. Selalu pakai Helm dengan pelindung wajah terpasang (saat tidak sendirian).";
      // text +=
      //   "&nbsp;&nbsp;&nbsp;&nbsp;2. Cuci tangan dengan sabun sebelum menyentuh masker, bagian wajah, dan makan.";
      // text +=
      //   "&nbsp;&nbsp;&nbsp;&nbsp;3. Makan minum sendiri2 dan hindari berkumpul di keramaian banyak orang.";
      return text;
    }
  },
  methods: {
    init: function() {
      const nik = localStorage.getItem("nik");
      // const division = Number(localStorage.getItem("division_id"));
      // nav.items.forEach((v, k) => {
      //   if (v.access.length === 0) {
      //     this.nav.push(v);
      //   } else {
      //     if (v.access[0].division.includes(division)) {
      //       if(v.children !== undefined) {
      //         let temp = [];
      //           v.children.forEach((ch_v, ch_k)=>{
      //             if(ch_v.access.length > 0 && ch_v.access[0].division.includes(division)) {
      //               temp.push(ch_v);
      //             }
      //           });
      //           v.children = temp;
      //           this.nav.push(v);
      //       } else {
      //         this.nav.push(v);
      //       }
      //     }
      //   }
      // });
      this.getMenu(nik);
    },
    getMenu: function(nik) {
      this.axios
        .get("web/menu/all-menu/" + nik + "/")
        .then(response => {
          this.nav = Object.keys(response.data.data).map(key => {
            return response.data.data[key];
          });
          //this.nav = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
